import VenueImages from './VenueImages';

export default VenueImages;
